module.exports = __webpack_public_path__ + "img/fj-labs.21182d88.svg";